export default "__VITE_ASSET__oJ4gbLh$__"